var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DesktopDatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import { useMediaQuery, useThemeProps } from '@mui/material';
export const DatePickerField = React.forwardRef(function DatePickerField(props, ref) {
    const themeProps = useThemeProps({ props, name: 'MuiDatePicker' });
    const { desktopModeMediaQuery = '@media (pointer: fine)', PopperProps = {
        placement: 'bottom-end',
    }, TransitionComponent, DialogProps, disableHighlightToday = true } = themeProps, rest = __rest(themeProps, ["desktopModeMediaQuery", "PopperProps", "TransitionComponent", "DialogProps", "disableHighlightToday"]);
    const isDesktop = useMediaQuery(desktopModeMediaQuery, { defaultMatches: true });
    if (isDesktop) {
        return (React.createElement(DesktopDatePicker, Object.assign({ ref: ref, disableHighlightToday: disableHighlightToday, PopperProps: PopperProps, TransitionComponent: TransitionComponent }, rest)));
    }
    return React.createElement(MobileDatePicker, Object.assign({ ref: ref, disableHighlightToday: disableHighlightToday, DialogProps: DialogProps }, rest));
});
